import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "./index.css";
import { jsx as e, jsxs as a, Fragment as i } from "react/jsx-runtime";
import { Container as n } from "@design-system/container";
import { SearchBlock as l } from "@design-system/search-block";
import { Section as s } from "@design-system/section";
import t from "classnames";
import r, { useState as o, useEffect as c, useCallback as d, forwardRef as g, useRef as h } from "react";
import { Link as b } from "@design-system/link";
import { Button as u } from "@design-system/button";
import m from "focus-trap-react";
import { ExtendableImage as p } from "@design-system/extendable-image";
import { Tooltip as v } from "@design-system/tooltip";
import { isBrowser as _ } from "@phx-husky/browser-helpers";
import { useScreenRecognition as f } from "@phx-husky/use-screen-recognition";
import { Icon as k } from "@design-system/icon";
var O = function O(_ref) {
    var a = _ref.burgerCloseIcon,
      i = _ref.burgerCloseLabel,
      n = _ref.isJS;
    return n ? null : e(b, Object.assign({
      className: "cds-global-header__burger-closer",
      variant: "subtle-icon",
      href: "#close-menu",
      size: "large",
      iconSuffix: {
        props: a
      }
    }, {
      children: i
    }));
  },
  N = function N(_ref2) {
    var a = _ref2.burgerCloseIcon,
      i = _ref2.burgerOpenLabel,
      n = _ref2.burgerOpenIcon,
      l = _ref2.burgerToggleLabel,
      s = _ref2.handleBurgerClick,
      t = _ref2.isOpen,
      r = _ref2.isJS,
      o = _ref2.burgerBtnRef,
      c = _ref2.isMobileView;
    return r && c ? e(u, Object.assign({
      ref: o,
      variant: "subtle-icon",
      className: "cds-navigation-mobile__burger",
      size: "large",
      iconSuffix: {
        props: t ? a : n
      },
      onClick: s,
      "aria-expanded": !!t
    }, {
      children: l
    })) : r && !c ? null : e(b, Object.assign({
      className: "cds-global-header__burger-opener",
      variant: "subtle-icon",
      href: "#open-menu",
      size: "large",
      iconSuffix: {
        props: n
      }
    }, {
      children: i
    }));
  },
  w = function w(_ref3) {
    var a = _ref3.ariaLabel,
      i = _ref3.href,
      _ref3$LinkComponent = _ref3.LinkComponent,
      n = _ref3$LinkComponent === void 0 ? b : _ref3$LinkComponent,
      l = _ref3.itemsQuantity;
    return e(n, Object.assign({
      className: t("cds-shopping-cart-icon", {
        "cds-shopping-cart-icon--no-items": 0 === l
      }),
      variant: "subtle-icon",
      size: "small",
      href: i,
      iconSuffix: {
        props: {
          icon: "shoppingCart"
        }
      },
      "aria-label": a
    }, {
      children: l
    }));
  },
  y = function y(_ref4) {
    var a = _ref4.isOpen,
      i = _ref4.isJS,
      n = _ref4.isMobileView,
      l = _ref4.children;
    var s = a && i && n ? m : r.Fragment;
    return e(s, {
      children: l
    });
  },
  j = function j(_ref5) {
    var a = _ref5.className,
      i = _ref5.image,
      n = _ref5.link,
      l = _ref5.onClick;
    var s = (null == n ? void 0 : n.component) || b,
      r = null == n ? void 0 : n.props;
    return e("div", Object.assign({
      className: t("cds-logo", a)
    }, {
      children: n && r ? e(s, Object.assign({
        onClick: l
      }, r, {
        className: "cds-logo__link",
        variant: "wrapper",
        tabIndex: -1,
        "aria-hidden": "true"
      }, {
        children: e(p, Object.assign({}, i))
      })) : e(p, Object.assign({}, i))
    }));
  },
  I = "cds-global-header__more-item",
  L = function L() {
    var _f = f(),
      e = _f.isMobile,
      a = _f.isDesktop;
    return {
      isDesktopView: _() && a,
      isMobileView: _() && e
    };
  },
  C = function C() {
    var _o = o(!1),
      _o2 = _slicedToArray(_o, 2),
      e = _o2[0],
      a = _o2[1];
    return c(function () {
      a(!0);
    }, []), [e];
  },
  M = function M(_ref6) {
    var e = _ref6.listRef,
      a = _ref6.navRef,
      i = _ref6.navigationData;
    var _L = L(),
      n = _L.isMobileView,
      _o3 = o(i),
      _o4 = _slicedToArray(_o3, 2),
      l = _o4[0],
      s = _o4[1],
      _o5 = o([]),
      _o6 = _slicedToArray(_o5, 2),
      t = _o6[0],
      r = _o6[1],
      _o7 = o(null),
      _o8 = _slicedToArray(_o7, 2),
      g = _o8[0],
      h = _o8[1],
      _o9 = o(0),
      _o10 = _slicedToArray(_o9, 2),
      b = _o10[0],
      u = _o10[1],
      _o11 = o(0),
      _o12 = _slicedToArray(_o11, 2),
      m = _o12[0],
      p = _o12[1],
      _o13 = o(0),
      _o14 = _slicedToArray(_o13, 2),
      v = _o14[0],
      _ = _o14[1],
      _o15 = o(0),
      _o16 = _slicedToArray(_o15, 2),
      f = _o16[0],
      k = _o16[1];
    c(function () {
      if ((null == e ? void 0 : e.current) && !n) {
        var _a = {
            navItems: [],
            moreBtnWidth: 0,
            langSwitchBtnWidth: 0
          },
          _n = Array.from(e.current.children);
        if (_n.filter(function (_ref7) {
          var e = _ref7.className;
          return e.includes("cds-global-header__navigation-item") && !e.includes(I);
        }).length !== i.length) return;
        _n.forEach(function (e) {
          e.className.includes("cds-global-header__navigation-item") && !e.className.includes(I) && _a.navItems.push({
            width: e.clientWidth
          }), e.className.includes(I) && (_a.moreBtnWidth = e.clientWidth), e.className.includes("cds-global-header__lang-switch") && (_a.langSwitchBtnWidth = e.clientWidth);
        }), h(_a);
      }
    }, [e, i, n]);
    var O = d(function () {
      if (g && a.current) {
        var _e = a.current.offsetWidth,
          _n2 = g.navItems,
          _l = g.moreBtnWidth,
          _t = g.langSwitchBtnWidth;
        var _o17 = _t + _l + b + m + v + f;
        var _c = [],
          _d = [];
        _n2.forEach(function (a, n) {
          _o17 += a.width, _e >= _o17 ? _c.push(i[n]) : _d.push(i[n]);
        }), s(_c), r(_d);
      }
    }, [m, b, a, i, g, v, f]);
    c(function () {
      O();
    }, [O, n]);
    var N = function (e) {
      var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
      var i = a;
      var n;
      return function (a) {
        n && clearTimeout(n), n = setTimeout(e, i, a);
      };
    }(O, 400);
    return c(function () {
      return n ? window.removeEventListener("resize", N) : window.addEventListener("resize", N), function () {
        window.removeEventListener("resize", N);
      };
    }, [N, g, n]), c(function () {
      var a;
      if (e.current && !n) return a = new ResizeObserver(function (e) {
        var a = Array.from(e[0].target.children),
          i = a.filter(function (e) {
            return !e.className.includes("cds-global-header__navigation-logo");
          }),
          n = a.find(function (e) {
            return e.className.includes("cds-global-header__navigation-logo");
          }),
          l = a.find(function (e) {
            return e.className.includes("cds-global-header__navigation-search");
          }),
          s = a.find(function (e) {
            return e.className.includes("cds-global-header__cart-icon");
          }),
          t = a.find(function (e) {
            return e.className.includes("cds-global-header__navigation-profile");
          });
        if (i.forEach(function (e) {
          return e.classList.add("cds-global-header__navigation-item--hidden");
        }), null == n ? void 0 : n.clientWidth) {
          var _e2 = getComputedStyle(n),
            _a2 = parseFloat(_e2.paddingRight),
            _l2 = getComputedStyle(i[0]),
            _s = parseFloat(_l2.paddingLeft);
          u(n.clientWidth + _s + _a2);
        }
        (null == l ? void 0 : l.clientWidth) && p(l.clientWidth), (null == s ? void 0 : s.clientWidth) && _(s.clientWidth), (null == t ? void 0 : t.clientWidth) && k(t.clientWidth), i.forEach(function (e) {
          return e.classList.remove("cds-global-header__navigation-item--hidden");
        });
      }), a.observe(e.current), function () {
        a.disconnect();
      };
      e.current && n && a && a.disconnect();
    }, [e, n]), {
      visibleItems: l,
      hiddenItems: t
    };
  },
  S = function S(e, a) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "or";
    return !!e && ("or" === i ? a.some(function (e) {
      return e;
    }) : "and" === i && a.every(function (e) {
      return e;
    }));
  };
function B(e, a, i) {
  return a in e ? Object.defineProperty(e, a, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[a] = i, e;
}
function D(e, a) {
  var i = {};
  for (var n in e) {
    Object.prototype.hasOwnProperty.call(e, n) && a.indexOf(n) < 0 && (i[n] = e[n]);
  }
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var l = 0;
    for (n = Object.getOwnPropertySymbols(e); l < n.length; l++) {
      a.indexOf(n[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[l]) && (i[n[l]] = e[n[l]]);
    }
  }
  return i;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var E = g(function (a, i) {
  var n,
    l = a.content,
    s = a.tag,
    r = void 0 === s ? "div" : s,
    o = a.variant,
    c = a.align,
    d = a.className,
    g = a.size,
    h = void 0 === g ? "m" : g,
    u = a.weight,
    m = void 0 === u ? "regular" : u,
    p = a.wrapping,
    v = void 0 === p ? "break-word" : p,
    _ = a.link,
    f = function (e, a) {
      var i = {};
      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && a.indexOf(n) < 0 && (i[n] = e[n]);
      }
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var l = 0;
        for (n = Object.getOwnPropertySymbols(e); l < n.length; l++) {
          a.indexOf(n[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[l]) && (i[n[l]] = e[n[l]]);
        }
      }
      return i;
    }(a, ["content", "tag", "variant", "align", "className", "size", "weight", "wrapping", "link"]),
    k = (null == _ ? void 0 : _.component) || b,
    O = function (e) {
      var a,
        i = e.align,
        n = e.variant,
        l = e.wrapping,
        s = e.size,
        r = e.weight,
        o = "body" === n || "headline" === n || "detail" === n;
      return t("cds-typography", e.className, (B(a = {}, "cds-typography--align-".concat(i), i), B(a, "cds-typography--variant-".concat(n), n), B(a, "cds-typography--variant-".concat(n, "-").concat(s), o && s), B(a, "cds-typography--wrapping-".concat(l), l), B(a, "cds-typography--weight-".concat(r), o && r), a));
    }({
      align: c,
      variant: o,
      wrapping: v,
      className: d,
      size: h,
      weight: m
    }),
    N = r && "rte" !== o ? r : "div",
    w = (n = l, "rte" !== o && "div" !== r ? n.toString().replace(/^<\/?[^>]+(>|$)/g, "").replace(/<\/[^>]+(>$)/g, "") : n);
  return e(N, _ ? Object.assign({
    className: O,
    ref: i
  }, f, {
    children: e(k, Object.assign({}, _.props, {
      iconPrefix: void 0,
      iconSuffix: void 0
    }, {
      children: e("span", {
        dangerouslySetInnerHTML: {
          __html: w
        }
      })
    }))
  }) : Object.assign({
    className: O,
    ref: i,
    dangerouslySetInnerHTML: {
      __html: w
    }
  }, f));
});
var x = function x() {
    var _o18 = o(!1),
      _o19 = _slicedToArray(_o18, 2),
      e = _o19[0],
      a = _o19[1],
      i = h(),
      _L2 = L(),
      n = _L2.isDesktopView,
      l = function l() {
        n && (i.current = setTimeout(function () {
          a(!1);
        }, 100));
      },
      s = function s(e) {
        "Escape" === e.key && (i.current && clearTimeout(i.current), a(!1));
      };
    return c(function () {
      return window.addEventListener("keyup", s), function () {
        window.removeEventListener("keyup", s);
      };
    }, []), {
      handleDesktopBlur: l,
      handleDesktopOutsideBlur: function handleDesktopOutsideBlur(e) {
        if (e.currentTarget.contains(e.relatedTarget) && n) return e.preventDefault(), void e.stopPropagation();
        l();
      },
      handleFocus: function handleFocus() {
        i.current && clearTimeout(i.current);
      },
      handleShowMoreClick: function handleShowMoreClick(e) {
        e.preventDefault(), a(function (e) {
          return !e;
        });
      },
      handleMenuItemClick: function handleMenuItemClick(e, i, l) {
        n || (i ? (e.preventDefault(), a(function (e) {
          return !e;
        })) : l());
      },
      handleKeyPress: function handleKeyPress(e) {
        " " !== e.key && "Spacebar" !== e.key && "Enter" !== e.key || (e.preventDefault(), a(function (e) {
          return !e;
        }));
      },
      handleMouseOver: function handleMouseOver(i) {
        i.preventDefault(), e || a(!0);
      },
      isOpen: e
    };
  },
  V = function V(e, a, i) {
    var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
    return n && e && a ? {
      props: i ? a : e
    } : void 0;
  },
  z = function z(e) {
    return e ? "large" : "small";
  },
  P = function P(_ref8) {
    var i = _ref8.title,
      n = _ref8.ariaLabel,
      l = _ref8.languageData,
      _ref8$linkNavElement = _ref8.linkNavElement,
      s = _ref8$linkNavElement === void 0 ? b : _ref8$linkNavElement,
      r = _ref8.openIcon,
      o = _ref8.closeIcon,
      c = _ref8.isMobileView,
      d = _ref8.isDesktopView;
    var _x = x(),
      g = _x.handleDesktopBlur,
      h = _x.handleDesktopOutsideBlur,
      m = _x.handleFocus,
      p = _x.handleShowMoreClick,
      v = _x.handleKeyPress,
      _ = _x.isOpen,
      f = _x.handleMouseOver,
      k = d ? f : void 0;
    return a("li", Object.assign({
      className: t("cds-global-header__navigation-item", "cds-global-header__navigation-item--has-children", "cds-global-header__lang-switch"),
      onBlur: h,
      onMouseLeave: g
    }, {
      children: [e(u, Object.assign({
        onKeyDown: v,
        onClick: p,
        onBlur: g,
        onMouseOver: k,
        variant: "nav",
        size: z(c),
        "aria-label": n,
        "aria-expanded": _,
        className: t("cds-global-header__lang-switch-btn", {
          active: _
        }),
        iconPrefix: {
          props: {
            icon: "translation",
            className: "cds-global-header__lang-switch-icon"
          }
        },
        iconSuffix: V(r, o, _, d)
      }, {
        children: i
      })), c ? e(u, Object.assign({
        variant: "nav",
        onClick: p,
        onKeyDown: v,
        size: z(c),
        className: "cds-global-header__navigation-arrow",
        "aria-expanded": _,
        iconSuffix: V(r, o, _)
      }, {
        children: i
      })) : null, _ ? e("div", Object.assign({
        className: "cds-global-header__navigation-drop"
      }, {
        children: e("ul", Object.assign({
          className: "cds-global-header__lang-list"
        }, {
          children: l.map(function (a) {
            var i = a.label,
              n = a.href,
              l = a.locale,
              t = a.translated,
              r = D(a, ["label", "href", "locale", "translated"]);
            return e("li", {
              children: t ? e(s, Object.assign({
                className: "cds-global-header__lang-link"
              }, r, {
                href: n,
                onClick: g,
                variant: "nav",
                size: z(c),
                onFocus: m,
                onBlur: g
              }, {
                children: i
              })) : e(E, {
                className: "cds-global-header__lang-item",
                content: i,
                tag: "span",
                variant: "body"
              })
            }, l);
          })
        }))
      })) : null]
    }));
  },
  W = function W(_ref9) {
    var i = _ref9.className,
      n = _ref9.subItems,
      _ref9$linkNavElement = _ref9.linkNavElement,
      l = _ref9$linkNavElement === void 0 ? b : _ref9$linkNavElement,
      s = _ref9.subMenuLabel,
      r = _ref9.activeUrlPath,
      o = _ref9.handleFocus,
      c = _ref9.handleBlur,
      d = _ref9.isMobileView,
      g = _ref9.href,
      h = _ref9.ariaLabel,
      u = _ref9.handleMobileNavigationItemClick,
      m = _ref9.onClickSubnavItem;
    return e("div", Object.assign({
      className: t("cds-global-header__navigation-drop", i)
    }, {
      children: a("ul", Object.assign({
        className: "cds-global-header__sub-list"
      }, {
        children: [S(s, [d]) && e("li", Object.assign({
          className: "cds-navigation__sub-item"
        }, {
          children: e(l, Object.assign({
            className: t("cds-navigation__sub-link", {
              active: r === g
            }),
            "aria-current": r === g,
            "aria-label": h,
            onClick: u,
            href: g,
            variant: "nav",
            size: "large",
            onFocus: o,
            onBlur: c
          }, {
            children: s
          }))
        })), n.map(function (a) {
          var i = a.label,
            n = a.href,
            s = a.ariaLabel,
            g = D(a, ["label", "href", "ariaLabel"]);
          return e("li", {
            children: e(l, Object.assign({
              className: t("cds-global-header__sub-link", {
                active: r === n
              }),
              "aria-current": r === n
            }, g, {
              "aria-label": s,
              onClick: function onClick() {
                return function (e) {
                  m && m(e), d && u();
                }(i);
              },
              href: n,
              variant: "nav",
              size: z(d),
              onFocus: o,
              onBlur: c
            }, {
              children: i
            }))
          }, i);
        })]
      }))
    }));
  },
  T = function T(_ref10) {
    var i = _ref10.className,
      n = _ref10.linkNavElement,
      l = _ref10.activeUrlPath,
      _ref10$href = _ref10.href,
      s = _ref10$href === void 0 ? "" : _ref10$href,
      r = _ref10.ariaLabel,
      o = _ref10.isMobileView,
      c = _ref10.isDesktopView,
      d = _ref10.label,
      g = _ref10.subItems,
      h = _ref10.subMenuLabel,
      m = _ref10.isJS,
      p = _ref10.openIcon,
      v = _ref10.closeIcon,
      _ = _ref10.expandTitle,
      f = _ref10.onClickNavItem,
      k = _ref10.handleMobileNavigationItemClick;
    var O = n || b,
      _x2 = x(),
      N = _x2.handleDesktopBlur,
      w = _x2.handleDesktopOutsideBlur,
      y = _x2.handleFocus,
      j = _x2.handleMenuItemClick,
      I = _x2.handleKeyPress,
      L = _x2.isOpen,
      C = _x2.handleMouseOver,
      M = g && c ? C : void 0,
      B = function B(e) {
        f && f(d), j(e, Boolean(null == g ? void 0 : g.length), k);
      };
    return a("li", Object.assign({
      className: t("cds-global-header__navigation-item", i, {
        "cds-global-header__navigation-item--has-children": Boolean(g)
      }),
      onBlur: w,
      onMouseLeave: N
    }, {
      children: [e(O, Object.assign({
        className: t("cds-global-header__navigation-link", {
          active: (D = l, E = s, P = g || [], P.some(function (e) {
            return D.includes(e.href);
          }) || D === E),
          "has-submenu": Boolean(null == g ? void 0 : g.length)
        }),
        onClick: B,
        "aria-current": l === s,
        onMouseOver: M,
        href: s,
        variant: "nav",
        size: z(o),
        "aria-label": r
      }, {
        children: d
      })), S(d, [m, Boolean(g)], "and") ? e(u, Object.assign({
        variant: "nav",
        onClick: B,
        onKeyDown: I,
        onMouseOver: M,
        size: z(o),
        className: "cds-global-header__navigation-arrow",
        "aria-expanded": L,
        iconSuffix: V(p, v, L)
      }, {
        children: "".concat(_, " ").concat(d)
      })) : null, S(g, [L], "or") && e(W, {
        subItems: g,
        activeUrlPath: l,
        subMenuLabel: h,
        linkNavElement: n,
        handleFocus: y,
        handleBlur: N,
        isMobileView: o,
        href: s,
        ariaLabel: r,
        handleMobileNavigationItemClick: k,
        onClickSubnavItem: f
      })]
    }));
    var D, E, P;
  },
  R = function R(_ref11) {
    var n = _ref11.headline,
      l = _ref11.greeting,
      s = _ref11.icon.icon,
      t = _ref11.account,
      r = _ref11.orders,
      o = _ref11.savedProducts,
      c = _ref11.register,
      d = _ref11.logIn,
      g = _ref11.logOut,
      h = _ref11.isSignedIn,
      m = _ref11.handleSignOut,
      p = _ref11.handleLogIn,
      v = _ref11.handleRegister,
      _ = _ref11.userName,
      _ref11$linkNavElement = _ref11.linkNavElement,
      f = _ref11$linkNavElement === void 0 ? b : _ref11$linkNavElement,
      O = _ref11.isMobileView;
    return e("div", Object.assign({
      className: "cds-global-header-profile"
    }, {
      children: a(i, h ? {
        children: [e(E, {
          className: "cds-global-header-profile__greeting",
          variant: "body",
          weight: "medium",
          size: "m",
          tag: "p",
          content: "".concat(l).concat(null != _ ? _ : "", " \uD83D\uDC4B")
        }), e(f, Object.assign({
          className: "cds-global-header-profile__link"
        }, r)), e(f, Object.assign({
          className: "cds-global-header-profile__link"
        }, o)), e(f, Object.assign({
          className: "cds-global-header-profile__link"
        }, t)), e(u, Object.assign({
          className: "cds-global-header-profile__button cds-global-header-profile__button--log-out"
        }, g, {
          variant: O ? "primary" : "secondary",
          onClick: m
        }))]
      } : {
        children: [a("div", Object.assign({
          className: "cds-global-header-profile__headline-wrapper"
        }, {
          children: [O ? e(k, {
            className: "cds-global-header-profile__headline-icon",
            icon: s
          }) : null, e(E, {
            className: "cds-global-header-profile__headline",
            variant: "body",
            weight: "medium",
            size: "m",
            tag: "p",
            content: n
          })]
        })), a("div", Object.assign({
          className: "cds-global-header-profile__buttons-wrapper"
        }, {
          children: [e(u, Object.assign({
            className: "cds-global-header-profile__button cds-global-header-profile__button--register"
          }, c, {
            onClick: v
          })), e(u, Object.assign({
            className: "cds-global-header-profile__button cds-global-header-profile__button--log-in"
          }, d, {
            onClick: p
          }))]
        }))]
      })
    }));
  },
  F = function F(_ref12) {
    var i = _ref12.navigationName,
      n = _ref12.navigationData,
      s = _ref12.linkNavElement,
      r = _ref12.onClickNavItem,
      o = _ref12.className,
      c = _ref12.closeIcon,
      d = _ref12.openIcon,
      g = _ref12.activeUrlPath,
      b = _ref12.logo,
      u = _ref12.moreBtn,
      m = _ref12.handleMobileNavigationItemClick,
      p = _ref12.languageSwitch,
      _ = _ref12.search,
      f = _ref12.cartIcon,
      k = _ref12.profile;
    var O = h(null),
      N = h(null),
      _L3 = L(),
      y = _L3.isMobileView,
      B = _L3.isDesktopView,
      _C = C(),
      _C2 = _slicedToArray(_C, 1),
      D = _C2[0],
      _M = M({
        navigationData: n,
        listRef: O,
        navRef: N
      }),
      E = _M.visibleItems,
      x = _M.hiddenItems;
    return e("nav", Object.assign({
      ref: N,
      className: t("cds-global-header__navigation", o),
      "aria-label": i
    }, {
      children: a("ul", Object.assign({
        ref: O,
        className: "cds-global-header__navigation-list"
      }, {
        children: [b && e("li", Object.assign({
          className: "cds-global-header__navigation-logo"
        }, {
          children: e(j, {
            className: "cds-global-header__desktop-logo",
            image: b.imageLarge,
            link: b.link
          })
        })), E.map(function (a) {
          return e(T, Object.assign({
            linkNavElement: s,
            activeUrlPath: g,
            isMobileView: y,
            isDesktopView: B,
            openIcon: d,
            closeIcon: c,
            expandTitle: u.title,
            isJS: D,
            onClickNavItem: r,
            handleMobileNavigationItemClick: m
          }, a), a.label);
        }), S(u, [D, !y, (null == x ? void 0 : x.length) > 0], "and") ? e(T, {
          className: t(I, _defineProperty({}, "".concat(I, "--hidden"), !n.length)),
          linkNavElement: s,
          activeUrlPath: g,
          isMobileView: !1,
          isDesktopView: B,
          openIcon: d,
          closeIcon: c,
          expandTitle: u.title,
          subItems: x,
          ariaLabel: null == u ? void 0 : u.ariaLabel,
          handleMobileNavigationItemClick: m,
          isJS: D,
          label: u.title,
          onClickNavItem: r,
          href: "/#more"
        }) : null, p ? e(P, Object.assign({
          linkNavElement: s,
          openIcon: d,
          closeIcon: c,
          isMobileView: y,
          isDesktopView: B
        }, p)) : null, _ && !y ? e("li", Object.assign({
          className: "cds-global-header__navigation-search\n                        cds-global-header__navigation-icon"
        }, {
          children: e(l, Object.assign({}, _, {
            handleBurgerMenu: m
          }))
        })) : null, f && B ? e("li", Object.assign({
          className: t("cds-global-header__cart-icon", "cds-global-header__navigation-icon")
        }, {
          children: e(w, Object.assign({}, f))
        })) : null, k ? e("li", Object.assign({
          className: t("cds-global-header__navigation-profile", {
            "cds-global-header__navigation-icon": B
          })
        }, {
          children: B ? e(v, {
            tooltipWindowClassName: "cds-global-header-profile-window",
            portalQuerySelector: ".cds-tooltip",
            label: k.headline,
            isTooltipContentInteractive: !0,
            icon: "profile",
            content: e(R, Object.assign({}, k))
          }) : e(R, Object.assign({}, k, {
            isMobileView: y
          }))
        })) : null]
      }))
    }));
  },
  J = function J(a) {
    var i = a.children,
      n = a.mode,
      l = D(a, ["children", "mode"]);
    return e(s, Object.assign({
      element: "div",
      mode: n,
      className: "cds-skip-link"
    }, {
      children: e(b, Object.assign({
        className: "cds-skip-link__link"
      }, l, {
        children: i
      }))
    }));
  },
  U = function U(_ref13) {
    var _ref13$linkNavElement = _ref13.linkNavElement,
      a = _ref13$linkNavElement === void 0 ? b : _ref13$linkNavElement,
      _ref13$utilityLinksDa = _ref13.utilityLinksData,
      i = _ref13$utilityLinksDa === void 0 ? [] : _ref13$utilityLinksDa,
      n = _ref13.utilityLinksName;
    return e("nav", Object.assign({
      "aria-label": n,
      className: "cds-utility-navigation"
    }, {
      children: e("ul", Object.assign({
        className: "cds-utility-navigation__list"
      }, {
        children: i.map(function (i) {
          var n = i.href,
            l = i.label,
            s = i.ariaLabel,
            t = D(i, ["href", "label", "ariaLabel"]);
          return e("li", Object.assign({
            className: "cds-utility-navigation__item"
          }, {
            children: e(a, Object.assign({
              className: "cds-utility-navigation__link",
              href: n,
              variant: "subtle",
              size: "small",
              "aria-label": s
            }, t, {
              children: l
            }))
          }), l);
        })
      }))
    }));
  },
  $ = function $(_ref14) {
    var i = _ref14.className,
      r = _ref14.logo,
      _ref14$isHeaderSticky = _ref14.isHeaderSticky,
      g = _ref14$isHeaderSticky === void 0 ? !1 : _ref14$isHeaderSticky,
      b = _ref14.skipLink,
      u = _ref14.utilityLinksData,
      m = _ref14.utilityLinksName,
      p = _ref14.mode,
      v = _ref14.linkNavElement,
      _ = _ref14.onClickNavItem,
      f = _ref14.burgerToggleLabel,
      k = _ref14.burgerOpenLabel,
      I = _ref14.burgerCloseLabel,
      M = _ref14.burgerOpenIcon,
      B = _ref14.burgerCloseIcon,
      D = _ref14.navigationName,
      E = _ref14.navigationData,
      x = _ref14.activeUrlPath,
      V = _ref14.moreBtn,
      z = _ref14.openIcon,
      P = _ref14.closeIcon,
      W = _ref14.languageSwitch,
      T = _ref14.search,
      R = _ref14.cartIcon,
      $ = _ref14.profile,
      K = _ref14.renderOnStart,
      H = _ref14.renderOnEnd,
      A = _ref14.renderOnBurgerPopupStart,
      Q = _ref14.renderOnBurgerPopupEnd,
      q = _ref14.uid;
    var G = h(null),
      _ref15 = function (e, a) {
        var _o20 = o(!1),
          _o21 = _slicedToArray(_o20, 2),
          i = _o21[0],
          n = _o21[1];
        return c(function () {
          var i = e.current;
          if (i && window) {
            var _e3 = new IntersectionObserver(function (_ref18) {
              var _ref19 = _slicedToArray(_ref18, 1),
                e = _ref19[0];
              n(e.intersectionRatio < 1), 1 === e.intersectionRatio && a && a(null == i ? void 0 : i.dataset.target);
            }, {
              threshold: [1, 0]
            });
            return _e3.observe(i), function () {
              _e3.unobserve(i);
            };
          }
        }, [e, a]), [i];
      }(G),
      _ref16 = _slicedToArray(_ref15, 1),
      X = _ref16[0],
      _C3 = C(),
      _C4 = _slicedToArray(_C3, 1),
      Y = _C4[0],
      _ref17 = function (e) {
        var a = "cds-scroll-locked",
          _L5 = L(),
          i = _L5.isDesktopView,
          _o22 = o(!1),
          _o23 = _slicedToArray(_o22, 2),
          n = _o23[0],
          l = _o23[1],
          _o24 = o(0),
          _o25 = _slicedToArray(_o24, 2),
          s = _o25[0],
          t = _o25[1],
          r = h(null),
          g = d(function () {
            i && l(!1);
          }, [i, l]);
        return c(function () {
          l(!1);
        }, []), c(function () {
          n ? document.documentElement.classList.add(a) : document.documentElement.classList.remove(a), r.current && r.current.focus();
        }, [n]), c(function () {
          return window.addEventListener("resize", g), window.addEventListener("orientationchange", g), function () {
            window.removeEventListener("resize", g), window.removeEventListener("orientationchange", g);
          };
        }, [g]), {
          isOpen: n,
          burgerBtnRef: r,
          handleBurgerClick: function handleBurgerClick(a) {
            a.preventDefault();
            var i = e.current;
            i && t(i.getBoundingClientRect().top + i.offsetHeight), l(!n);
          },
          burgerOffsetTop: s,
          handleMobileNavigationItemClick: function handleMobileNavigationItemClick() {
            l(!n);
          },
          handleMobileLogoClick: function handleMobileLogoClick() {
            l(!1);
          }
        };
      }(G),
      Z = _ref17.isOpen,
      ee = _ref17.burgerBtnRef,
      ae = _ref17.handleBurgerClick,
      ie = _ref17.burgerOffsetTop,
      ne = _ref17.handleMobileNavigationItemClick,
      le = _ref17.handleMobileLogoClick,
      _L4 = L(),
      se = _L4.isDesktopView,
      te = _L4.isMobileView;
    return c(function () {
      var e = document.getElementsByTagName("html")[0];
      g ? e.classList.add("has-sticky-nav") : e.classList.remove("has-sticky-nav");
    }, [g]), a(s, Object.assign({
      ref: G,
      element: "header",
      id: "open-menu",
      mode: p,
      removeDuplicateSpacing: !1,
      "data-status": Y ? "js" : "no-js",
      className: t("cds-global-header", i, {
        "cds-global-header--is-sticky": X && g,
        "cds-global-header--sticky-mode": g,
        "cds-global-header--burger-opened": te && Z
      }),
      "data-component-uid": q
    }, {
      children: [e(J, Object.assign({}, b)), e(n, Object.assign({
        maxWidth: "max-grid"
      }, {
        children: e(y, Object.assign({
          isOpen: Z,
          isMobileView: te,
          isJS: Y
        }, {
          children: a("div", {
            children: [K, a("div", Object.assign({
              className: "cds-global-header__mobile-main"
            }, {
              children: [r && e(j, {
                className: "cds-global-header__mobile-logo",
                image: r.imageSmall,
                link: r.link,
                onClick: le
              }), te && a("ul", Object.assign({
                className: "cds-global-header__navigation-wrapper"
              }, {
                children: [T ? e("li", Object.assign({
                  className: t("cds-global-header__navigation-search", "cds-global-header__navigation-icon")
                }, {
                  children: e(l, Object.assign({}, T, {
                    handleBurgerMenu: ne
                  }))
                })) : null, R ? e("li", Object.assign({
                  className: t("cds-global-header__cart-icon", "cds-global-header__navigation-icon")
                }, {
                  children: e(w, Object.assign({}, R))
                })) : null, e("li", {
                  children: e(N, {
                    burgerToggleLabel: f,
                    burgerOpenIcon: M,
                    burgerCloseIcon: B,
                    burgerOpenLabel: k,
                    isJS: Y,
                    handleBurgerClick: ae,
                    isOpen: Z,
                    burgerBtnRef: ee,
                    isMobileView: te
                  })
                })]
              }))]
            })), !Z && te && Y ? null : a("div", Object.assign({
              style: {
                top: "".concat(ie, "px")
              },
              className: "cds-global-header__burger-popup"
            }, {
              children: [A, e(O, {
                burgerCloseIcon: B,
                burgerCloseLabel: I,
                isJS: Y
              }), S(u, [!Y, se], "or") && e("div", Object.assign({
                className: "cds-global-header__top"
              }, {
                children: e(U, {
                  utilityLinksData: u,
                  linkNavElement: v,
                  utilityLinksName: m
                })
              })), e("div", Object.assign({
                className: "cds-global-header__desktop-main"
              }, {
                children: e(F, {
                  navigationName: D,
                  navigationData: E,
                  activeUrlPath: x,
                  linkNavElement: v,
                  handleMobileNavigationItemClick: ne,
                  logo: r,
                  moreBtn: V,
                  openIcon: z,
                  closeIcon: P,
                  languageSwitch: W,
                  search: T,
                  cartIcon: R,
                  onClickNavItem: _,
                  profile: $
                })
              })), S(u, [Y, te], "and") && e("div", Object.assign({
                className: "cds-global-header__bottom"
              }, {
                children: e(U, {
                  utilityLinksData: u,
                  linkNavElement: v,
                  utilityLinksName: m
                })
              })), Q]
            })), H]
          })
        }))
      }))]
    }));
  };
export { $ as GlobalHeader };